module.exports = __webpack_public_path__ + "img/Delivery-Range.280e02b8.jpg";